export class CountUsers {
    constructor(public management: number, public user: number, public total: number) {
    }
  }